/** @file timelineBindings: the timeline's key table (context `timeline`, `event.code` chords). */
import type { Binding } from '@zilo/pose3d-shortcuts/types';

/** First / last frame, delete keys, copy / paste pose; play, frame steps and keying are global (`transportBindings`). */
export const timelineBindings: Binding[] = [
  { id: 'timeline.firstFrame', keys: 'Home', context: 'timeline' },
  { id: 'timeline.lastFrame', keys: 'End', context: 'timeline' },
  { id: 'timeline.deleteKeys', keys: 'Delete', context: 'timeline' },
  { id: 'timeline.copyPose', keys: 'Mod+KeyC', context: 'timeline' },
  { id: 'timeline.pastePose', keys: 'Mod+KeyV', context: 'timeline' },
];
